import React, { useState, useEffect } from 'react';
import axios from 'axios'
import Select from 'react-select';
import './form.css';
import { AddRevenue } from '../../Redux/action/revenueAction';

import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwInput from '../Common/FormComponent/SwInput';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import { toast } from 'react-toastify';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()
let count = 0;
class PrinterScanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: '',
      location: '',
      location1: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      company_id: UserObj ? UserObj.company_id : null,
      userid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : null,
      locationError: '',
      dynamicFieldError: false,
      files: null,
      attachmentError: '',
      btnStatus: false,
      func: [{ color_type: '', no_of_prints: null }],
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }

  onPaxChange = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['no_of_prints'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };

  food = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['color_type'] = e?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName)
    this.setState({ locationNew: locationShort })
    this.setState({
      locationData: LocationSpoc,
    });
  }

  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      func: [
        {
          color_type: '',
          no_of_prints: '',
        },
      ],
      locationError: '',
      attachmentError: '',
      dynamicFieldError: false,
      attachmentError: '',
    });
    count = 0;
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };
  removeFormFields(i) {
    let formValues = this.state.func;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }

  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
    });
  };


  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    let files = this.state.files;
    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }
    let dynamicFieldError = false;
    this.state.func.forEach(item => {
      if (!(item.color_type && item.no_of_prints)) {
        dynamicFieldError = true;
      }
      else if (item.no_of_prints < 0) {
        dynamicFieldError = true;
      }
    });
    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });
    } else if (dynamicFieldError) {
      this.setState({ dynamicFieldError: dynamicFieldError });
    }
    else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      e.currentTarget.disabled = true
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.userid,
        email: this.state.email,
        category: 'printer_scanner',
        company_name: UserObj ? UserObj.company_name : null,
      };
      let body_param = {
        printer_scanner: this.state.func,
        notes: this.state.notes,
        location_name: this.state.location1,
      };

      param.common_param = common_param;
      param.body_param = body_param;
      // AddRevenue(param, formData);
      // this.setState({
      //   btnStatus: false,
      // });
      // e.currentTarget.disabled = false
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };

  render() {
    const options2 = [
      { value: 'black_white', label: 'Black & White' },
      { value: 'colored', label: 'Colored' },
    ];

    return (
      <>

        <div className="row">
          {' '}
          <div className="col-md-12 ">
            {' '}
            <div className="SwFormGroup">
              <label className="SwFormLabel">Location <span className="Required">*</span></label>
              <SwSelect
                name="location"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                id="printer-scanner-location-select"
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.locationError}
              </span>
            </div>
          </div>
        </div>
        {this.state.func.map((item, index) => {
          return (
            <div className="row">
              {' '}
              <div className="col-md-6 mt-2">
                {' '}
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Type of Prints <span className="Required">*</span></label>{' '}
                  <SwSelect
                    placeholder="Select"
                    options={options2}
                    key={`key-${index}`}
                    id={`printer-print-type-${index}`}
                    value={options2.filter(
                      option => option.value === item.color_type,
                    )}
                    onChange={e => this.food(e, index)}
                  />
                  {this.state.dynamicFieldError &&
                    !item.color_type && (
                      <span className="SwTextDanger SwTextSmall">
                        {"Type can't be Empty"}
                      </span>
                    )}
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Count <span className="Required">*</span></label>
                  <SwInput
                    type="number"
                    min="0"
                    value={item.no_of_prints}
                    id="printer-count-input"
                    onChange={e => {
                      this.onPaxChange(e, index);
                    }}
                  />

                  {(item.no_of_prints < 0 ||
                    (this.state.dynamicFieldError &&
                      !item.no_of_prints)) && (
                      <span className="SwTextDanger SwTextSmall">
                        {"No. of Print can't be Empty or negative"}
                      </span>
                    )}
                </div>
              </div>
              {index == 0 ? (
                <div className="">
                  {' '}
                  <a
                    type="button"
                    style={count + 1 < options2.length ? { color: "#0571c4" } : { color: "#63b4f2" }}
                    className="SwLinkInfo"
                    onClick={() => {
                      let tempState = [...this.state.func];
                      tempState.push({
                        color_type: '',
                        no_of_prints: null,
                      });
                      this.setState({
                        func: tempState,
                      });
                      {
                        count = count + 1;
                      }
                    }}
                    disabled={
                      count + 1 < options2.length ? false : true
                    }
                  >
                    <i class="bi bi-plus-circle" />{' '}
                    Add more
                  </a>
                </div>
              ) : (
                <div className="col-3">
                  {' '}
                  <a
                    type="button"
                    className="SwLinkDanger"
                    onClick={() => {
                      this.removeFormFields(index);
                      {
                        count = count - 1;
                      }
                    }}
                  >
                    <i className="bi bi-trash3-fill" />
                  </a>
                </div>
              )}
            </div>
          );
        })}

        <div className="row">
          <div className="col-md-12 col-xl-12 col-lg-12 mt-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Notes</label>
              <SwTextArea
                rows="4"
                id="printer-notes"
                value={this.state.notes}
                onChange={this.onNotes}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PrinterScanner;
